import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const Contacts = () => import(/* webpackChunkName: "contacts" */'@/views/contact/Contacts')
const ContactTabs = () => import(/* webpackChunkName: "contacts" */'@/views/contact/contact/ContactTabs')
const Overview = () => import(/* webpackChunkName: "contacts" */'@/views/contact/contact/Overview')

const SendInvite = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/SendInvite')
const InviteUser = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/InviteUser')
const InviteLegacy = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/InviteLegacy')
const RevokeInvite = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/RevokeInvite')
const DeactivateUser = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/DeactivateUser')
const DeleteUser = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/DeleteUser')
const ForcePasswordChange = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/ForcePasswordChange')
const SendPasswordReset = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/SendPasswordReset')
const Remove2Fa = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/Remove2Fa')

const ContactLogs = () => import(/* webpackChunkName: "customers" */'@/views/contact/contact/ContactLogs')
const PropertyHistoryTimeline = () => import(/* webpackChunkName: "customers" */'@/views/contact/contact/property-history/PropertyHistoryTimeline')
const UpdateProperty = () => import(/* webpackChunkName: "customers" */'@/views/contact/contact/property-history/UpdateProperty')

function props (route) {
    return {
        contactId: parseInt(route.params.contactId),
        property: route.params.property
    }
}

export default {
    path: '/customers/contacts',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            name: routeNames.CONTACTS,
            meta: {title: 'Contacts'},
            component: Contacts
        },
        {
            path: ':contactId',
            component: ContactTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CONTACT,
                    meta: {title: 'Contact'},
                    component: Overview,
                    props,
                    children: [
                        {
                            path: 'property/:property',
                            name: routeNames.CONTACT_PROPERTY_HISTORY_TIMELINE,
                            meta: {title: 'Property History Timeline'},
                            component: PropertyHistoryTimeline,
                            props
                        },
                        {
                            path: 'property/:property/update',
                            name: routeNames.CONTACT_PROPERTY_UPDATE,
                            meta: {title: 'Property Update'},
                            component: UpdateProperty,
                            props
                        }
                    ]
                },
                {
                    path: 'logs',
                    name: routeNames.CONTACT_LOGS,
                    meta: {title: 'Logs'},
                    props,
                    component: ContactLogs
                },
                {
                    path: 'invite-user',
                    name: routeNames.CONTACT_INVITE_USER,
                    meta: {title: 'Invite to WIMS'},
                    component: InviteUser,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'invite-legacy',
                    name: routeNames.CONTACT_INVITE_LEGACY,
                    meta: {title: 'Invite to My Windsor Legacy'},
                    component: InviteLegacy,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'send-invite',
                    name: routeNames.CONTACT_SEND_INVITE,
                    meta: {title: 'Resend WIMS activation email'},
                    component: SendInvite,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'revoke-invite',
                    name: routeNames.CONTACT_REVOKE_INVITE,
                    meta: {title: 'Revoke SSO Invite'},
                    component: RevokeInvite,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'deactivate-user',
                    name: routeNames.CONTACT_DEACTIVATE_USER,
                    meta: {title: 'Deactivate User'},
                    component: DeactivateUser,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'delete-user',
                    name: routeNames.CONTACT_DELETE_USER,
                    meta: {title: 'Delete User'},
                    component: DeleteUser,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'force-password',
                    name: routeNames.CONTACT_FORCE_PASSWORD,
                    meta: {title: 'Force Password Change'},
                    component: ForcePasswordChange,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'reset-password',
                    name: routeNames.CONTACT_RESET_PASSWORD,
                    meta: {title: 'Send Password Reset'},
                    component: SendPasswordReset,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
                {
                    path: 'remove-2fa',
                    name: routeNames.CONTACT_REMOVE_2FA,
                    meta: {title: 'Remove 2 Factor Authentication'},
                    component: Remove2Fa,
                    props: (route) => ({
                        contactId: Number(route.params.contactId),
                        customerId: Number(route.params.customerId),
                        type: "contact"
                    }),
                },
            ]
        }
    ]
}
